import { localStorageFacade } from '@townsquare/facade';

export const LAST_SELECTED_UPDATES_PAGE_KEY = 'lastSelectedUpdatesPage';
export const setLastSelectedUpdatesPage = (pageName: string) => {
  localStorageFacade.setItem(LAST_SELECTED_UPDATES_PAGE_KEY, pageName);
};
